import styled from "@emotion/styled";
import { ButtonProps, Button } from "@mui/material";

export const SmallButton = styled((props: ButtonProps) => (
    <Button
        variant="contained"
        size="small"
        sx={{
            typography: "body",
        }}
        disableRipple
        {...props}
    />
))({
    paddingBlock: "0.15rem",
    paddingLeft: "0.5rem",
    paddingRight: "1rem",
    textTransform: "none",
    backgroundColor: "white",
    color: "black",
    "&:hover": {
        backgroundColor: "white",
    },
})
